export default "__VITE_ASSET__m2k8DfOO__"